import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgCaretDownDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgCaretDown = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M17 10L12 16L7 10H17Z" fill="currentColor" />
  </svg>
));
